module.exports = __webpack_public_path__ + "img/img-5.36d7e167.svg";